import { render, staticRenderFns } from "./AddressAddModal.vue?vue&type=template&id=a99842c6"
import script from "./AddressAddModal.vue?vue&type=script&lang=js"
export * from "./AddressAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports